import React from 'react'

const Logo = ({ className }) => (
  <svg
    className={className}
    viewBox='0 0 400 60'
    version='1.1'
    id='Layer_1'
    xmlns='http://www.w3.org/2000/svg'
    xmlnsXlink='http://www.w3.org/1999/xlink'
    x='0px'
    y='0px'
    xmlSpace='preserve'
    style={{ verticalAlign: 'middle ' }}
  >
    <g>
      <g>
        <polygon
          className='st0'
          fill='#FF3228'
          points='73,62 37.5,62 55.2,33'
        ></polygon>
        <polygon
          className='st0'
          fill='#FF3228'
          points='1.9,62 55.2,33.3 37.5,4.6'
        ></polygon>
      </g>
      <g>
        <path
          className='st1'
          fill='#FFFFFF'
          d='M93.9,62l10.9-28.6h4.2L119.9,62h-3.8l-3-7.7h-12.5l-3,7.7H93.9z M101.6,51H112l-5.2-13.8L101.6,51z'
        ></path>
        <path
          className='st1'
          fill='#FFFFFF'
          d='M141.4,50.4V62h-3.4V50.6c0-4.3-2-6.6-5.6-6.6c-3.9,0-6.3,2.9-6.3,7.6V62h-3.4V41.1h2.9l0.5,2.8
			c1.2-1.6,3.4-3.1,6.9-3.1C137.7,40.9,141.4,43.4,141.4,50.4z'
        ></path>
        <path
          className='st1'
          fill='#FFFFFF'
          d='M165.1,58.9V62h-1.8c-2.8,0-3.7-1.2-3.8-3.2c-1.3,1.9-3.4,3.5-7,3.5c-4.6,0-7.7-2.3-7.7-6.1
			c0-4.2,2.9-6.5,8.4-6.5h6.1v-1.4c0-2.7-1.9-4.3-5.2-4.3c-2.9,0-4.9,1.4-5.3,3.5h-3.4c0.5-4.1,3.8-6.5,8.8-6.5
			c5.3,0,8.4,2.7,8.4,7.5v9.1c0,1.1,0.4,1.4,1.4,1.4H165.1z M159.3,52.4h-6.5c-3,0-4.7,1.1-4.7,3.5c0,2,1.8,3.4,4.5,3.4
			c4.2,0,6.6-2.4,6.6-5.9V52.4z'
        ></path>
        <path
          className='st1'
          fill='#FFFFFF'
          d='M168.1,33.3h3.4V62h-3.4V33.3z'
        ></path>
        <path
          className='st1'
          fill='#FFFFFF'
          d='M174.3,41.1h3.6l6.4,16.7l6.2-16.7h3.6l-9.6,24.4c-1.3,3.4-2.1,4.7-5,4.7h-4v-3.1h3c1.9,0,2.3-0.5,3-2.5
			l1-2.5L174.3,41.1z'
        ></path>
        <path
          className='st1'
          fill='#FFFFFF'
          d='M196.7,35.3h3.4v5.9h5.4v3.1h-5.4v12.3c0,1.8,0.6,2.4,2.4,2.4h3.3V62h-3.6c-4,0-5.4-1.8-5.4-5.4V35.3z'
        ></path>
        <path
          className='st1'
          fill='#FFFFFF'
          d='M208.7,35.4c0-1.3,0.9-2.2,2.2-2.2c1.2,0,2.2,0.9,2.2,2.2c0,1.3-0.9,2.2-2.2,2.2
			C209.6,37.6,208.7,36.7,208.7,35.4z M209.1,41.1h3.4V62h-3.4V41.1z'
        ></path>
        <path
          className='st1'
          fill='#FFFFFF'
          d='M216.7,51.6c0-6.4,4.1-10.7,10.2-10.7c5.1,0,8.3,2.9,9.2,7.4h-3.5c-0.6-2.8-2.7-4.5-5.7-4.5
			c-4,0-6.7,3.2-6.7,7.7s2.7,7.7,6.7,7.7c3,0,5-1.7,5.7-4.4h3.6c-0.8,4.5-4.2,7.4-9.3,7.4C220.7,62.2,216.7,58.1,216.7,51.6z'
        ></path>
        <path
          className='st1'
          fill='#FFFFFF'
          d='M248.6,33.3h11c5.7,0,9.5,3.4,9.5,8.8s-3.8,8.8-9.5,8.8h-7.4v11h-3.6V33.3z M252.1,36.6v11.1h7.1
			c3.8,0,6.2-2.2,6.2-5.6c0-3.4-2.4-5.5-6.1-5.5H252.1z'
        ></path>
        <path
          className='st1'
          fill='#FFFFFF'
          d='M291.1,58.9V62h-1.8c-2.8,0-3.7-1.2-3.8-3.2c-1.3,1.9-3.4,3.5-7,3.5c-4.6,0-7.7-2.3-7.7-6.1
			c0-4.2,2.9-6.5,8.4-6.5h6.1v-1.4c0-2.7-1.9-4.3-5.2-4.3c-2.9,0-4.9,1.4-5.3,3.5h-3.4c0.5-4.1,3.8-6.5,8.8-6.5
			c5.3,0,8.4,2.7,8.4,7.5v9.1c0,1.1,0.4,1.4,1.4,1.4H291.1z M285.3,52.4h-6.5c-3,0-4.7,1.1-4.7,3.5c0,2,1.8,3.4,4.5,3.4
			c4.2,0,6.6-2.4,6.6-5.9V52.4z'
        ></path>
        <path
          className='st1'
          fill='#FFFFFF'
          d='M304.7,41.1v3.3H303c-4.4,0-5.6,3.6-5.6,7V62h-3.4V41.1h2.9l0.5,3.2c1-1.6,2.6-3.2,6.3-3.2H304.7z'
        ></path>
        <path
          className='st1'
          fill='#FFFFFF'
          d='M307.7,35.3h3.4v5.9h5.4v3.1h-5.4v12.3c0,1.8,0.6,2.4,2.4,2.4h3.3V62h-3.6c-4,0-5.4-1.8-5.4-5.4V35.3z'
        ></path>
        <path
          className='st1'
          fill='#FFFFFF'
          d='M338.8,50.4V62h-3.4V50.6c0-4.3-2-6.6-5.6-6.6c-3.9,0-6.3,2.9-6.3,7.6V62h-3.4V41.1h2.9l0.5,2.8
			c1.2-1.6,3.4-3.1,6.9-3.1C335.1,40.9,338.8,43.4,338.8,50.4z'
        ></path>
        <path
          className='st1'
          fill='#FFFFFF'
          d='M342.5,51.5c0-6.3,4-10.7,9.9-10.7c5.9,0,9.7,3.7,9.9,9.9c0,0.5,0,0.9-0.1,1.4h-16.2v0.3
			c0.1,4,2.6,6.8,6.6,6.8c2.9,0,5.2-1.6,5.9-4.3h3.4c-0.8,4.2-4.3,7.2-9.1,7.2C346.6,62.2,342.5,57.9,342.5,51.5z M358.7,49.4
			c-0.3-3.6-2.8-5.6-6.3-5.6c-3.1,0-5.9,2.2-6.2,5.6H358.7z'
        ></path>
        <path
          className='st1'
          fill='#FFFFFF'
          d='M376.9,41.1v3.3h-1.7c-4.4,0-5.6,3.6-5.6,7V62h-3.4V41.1h2.9l0.4,3.2c1-1.6,2.6-3.2,6.3-3.2H376.9z'
        ></path>
        <path
          className='st1'
          fill='#FFFFFF'
          d='M381.6,55.1c0.1,2.5,2.3,4.3,5.8,4.3c2.9,0,5-1.3,5-3.2c0-2.6-2.3-2.8-5.4-3.2c-4.7-0.6-8.4-1.5-8.4-5.9
			c0-3.8,3.5-6.3,8.2-6.3c4.7,0,8.2,2.3,8.5,6.6h-3.4c-0.2-2.1-2.2-3.7-5.1-3.7c-2.9,0-4.9,1.2-4.9,3.2c0,2.3,2.2,2.6,5.2,2.9
			c4.7,0.6,8.6,1.5,8.6,6.1c0,3.9-3.7,6.3-8.3,6.3c-5.4,0-9.1-2.5-9.2-7.1H381.6z'
        ></path>
      </g>
    </g>
  </svg>
)

export default Logo
